export default __webpack_public_path__ + "images/link-54fb472377d003d5df4fb3b70ef2a892.svg";